import cn from 'classnames';
import { isFirstDayOfMonth } from 'date-fns';
import * as React from 'react';
import MediaQuery from 'react-responsive';
import { useTranslation } from 'react-i18next';
import { CdnIcon } from '@shared/ui/CdnIcon';
import { RouteType, getProgressLevel } from '@features/price-graph';
import { Money as MoneyComponent } from '../../../../../../Money/components/Money';
import { Tooltip } from '../../../../../../BaseComponents';
import { format, TABLET_MIN_WIDTH, removeDotsFromDate } from '../../../../../../utils';
import { useTheme } from '../../../../../../theme';
const Day = ({ date, price, maxPrice, minPrice, routeType, isBackDate, isOutDate, isFocused, isMobileMode, onSelect }) => {
    const { t } = useTranslation('PriceGraph');
    const { DayStyles: theme } = useTheme('Features').PriceGraph;
    const day = date.getDate(), dayOfWeek = format(date, 'eeeee'), progress = price && maxPrice ? getProgressLevel(price.amount, maxPrice.amount) : 0;
    const handleClick = () => {
        if (isMobileMode) {
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(date, routeType === RouteType.Return);
        }
        else if (price === null || price === void 0 ? void 0 : price.amount) {
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(date, routeType === RouteType.Return);
        }
    };
    const minPriceDay = minPrice && price && price.amount === minPrice.amount && price.amount;
    return (React.createElement("div", { className: cn(theme.day, {
            [theme.day_notAvailable]: !price || !price.amount,
            [theme.outDate]: isOutDate,
            [theme.backDate]: isBackDate,
            [theme.day_focused]: isFocused,
            [theme.minPrice]: minPriceDay
        }), onClick: handleClick },
        price.amount > 0 && (React.createElement("div", { className: theme.price },
            t('from'),
            React.createElement(MoneyComponent, { money: price }))),
        isFirstDayOfMonth(date) && React.createElement("div", { className: theme.monthName }, format(date, 'LLLL')),
        React.createElement(MediaQuery, { minWidth: TABLET_MIN_WIDTH + 1 },
            React.createElement(Tooltip, { disableHoverListener: !price.amount, title: React.createElement("div", { className: theme.tooltip__text },
                    React.createElement(CdnIcon, { className: cn({
                            [theme.tooltip__icon_return]: routeType === RouteType.Return
                        }), icon: 'Flight/Direction' }),
                    React.createElement("div", { className: theme.tooltip__text_box },
                        React.createElement("div", { className: theme.tooltip__date }, removeDotsFromDate(format(date, 'd MMM, EEEEEE'))),
                        React.createElement("div", { className: theme.tooltip__price },
                            t('from'),
                            " ",
                            React.createElement(MoneyComponent, { moneyClassName: theme.tooltip__money, money: price })))), placement: "bottom", classes: {
                    tooltip: theme.tooltip,
                    popper: theme.popper
                }, arrow: false },
                React.createElement("div", { className: theme.bar },
                    React.createElement("div", { className: theme.progress, style: price && price.amount ? { height: `${progress}%` } : null })))),
        React.createElement(MediaQuery, { maxWidth: TABLET_MIN_WIDTH },
            React.createElement("div", { className: theme.bar },
                React.createElement("div", { className: theme.progress, style: price.amount ? { height: `${progress}%` } : null }))),
        React.createElement("div", { className: theme.header },
            React.createElement("div", { className: cn(theme.number, {
                    [theme.outDate]: isOutDate,
                    [theme.backDate]: isBackDate
                }) }, day),
            React.createElement("div", { className: theme.dow }, dayOfWeek))));
};
export default Day;
